import "./CertificateSampleDataPanel.css";
import { FaTimes } from "react-icons/fa";

function CertificateSampleDataPanel({ fields, values, onChange, onClose, xsdVersion }) {
    return (
        <div
            className="certificate-sample-data-backdrop"
            onMouseDown={event => {
                if (event.target === event.currentTarget) onClose();
            }}
        >
            <section
                className="certificate-sample-data-dialog"
                role="dialog"
                aria-modal="true"
                aria-labelledby="certificate-sample-data-title"
            >
                <header className="certificate-sample-data-header">
                    <div>
                        <h2 id="certificate-sample-data-title">Datos de ejemplo</h2>
                        <p>
                            {xsdVersion
                                ? `Vista previa para la versión ${xsdVersion}. Los valores iniciales pueden venir del XSD.`
                                : "Estos valores se usan solo en la vista previa y el PDF del editor."}
                        </p>
                    </div>
                    <button type="button" aria-label="Cerrar datos de ejemplo" onClick={onClose}>
                        <FaTimes aria-hidden="true" />
                    </button>
                </header>

                <div className="certificate-sample-data-fields">
                    {fields.length === 0 ? (
                        <p className="certificate-sample-data-empty">
                            Agrega un campo dinámico al diseño para configurar valores de ejemplo.
                        </p>
                    ) : fields.map(field => (
                        <label className="certificate-sample-data-field" key={field}>
                            <span>{field}</span>
                            <input
                                type="text"
                                aria-label={`Valor de ejemplo para ${field}`}
                                value={values[field] ?? ""}
                                onChange={event => onChange(field, event.target.value)}
                                placeholder="Escribe un valor de ejemplo"
                            />
                        </label>
                    ))}
                </div>

                <footer className="certificate-sample-data-footer">
                    <span>Los cambios se guardan localmente al pulsar “Guardar cambios”.</span>
                    <button type="button" onClick={onClose}>Listo</button>
                </footer>
            </section>
        </div>
    );
}

export default CertificateSampleDataPanel;
